export const isValidWhitelistedReferrer = (referrerUrl: string, whitelistedDomain: string) => {
  try {
    const referrerHost = new URL(referrerUrl).hostname;
    const regex = new RegExp(`^(?:https?://)?(?:[^.]+\\.)*${whitelistedDomain}$`);
    return regex.test(referrerHost);
  } catch {
    return false;
  }
};
